module.exports = __webpack_public_path__ + "static/nasa2-frame-c0c932e1183ee738effaa07e6ed926c3.gif";